// import external dependencies
import 'jquery'

// Import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/functions-comunes.js'; import './autoload/functions-forms.js'; import './autoload/functions-initlisteners.js'; import './autoload/plugins'; import './autoload/plugins/chosen'; import './autoload/plugins/chosen/index.js'; import './autoload/plugins/iCheck'; import './autoload/plugins/iCheck/index.js'; import './autoload/plugins/index.js'

// FontAwesome 5 PRO
import { library, dom } from '@fortawesome/fontawesome-svg-core'
// import the Facebook and Twitter icons
import { faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons'
// add the imported icons to the library
library.add(faFacebook, faTwitter)
// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch()
//end FontAwesome

// import local dependencies
import Router from './util/Router'
import common from './routes/common'
import home from './routes/home'
import aboutUs from './routes/about'

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs
})

// Load Events
jQuery(document).ready(() => routes.loadEvents())



// WEBPACK FOOTER //
// ./scripts/main.js